import React from "react";
import { useState, useEffect, useRef, useContext } from "react";

//************** Componentes PrimerReact **************/
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';


//************** Componentes generales **************/
import Card from "../../Components/Card/Card";
import Loader from "../../Components/Loader/Loader";
import AgGrid from "../../Components/Tables/AgGrid/AgGrid";

//************** Consultas API **************/
import { getCustomers, putChecksCustomer, BlockCustomerIPS, getEnlaceInscripcion, updateEnlaceInscripcion, descargarArchivoBIC, descargarArchivoFactura, descargarArchivoPermiso, descargarArchivoEscritura, descargarArchivoConstancia, descargarArchivoRegistro, descargarArchivoEstados, descargarArchivoRepresentante, descargarArchivoRefComercial1, descargarArchivoRefComercial2, descargarArchivoRefBan1, descargarArchivoRefBan2, postChangeEstadoClientes, updateClienteNuevo, descargarArchivoCertificadoA, descargarArchivoCertificadoL, descargarArchivoFormatoInscripcion, ocultarClienteVentas, getInfoCliente, CambiarEstadoInscripcion } from "../../API/Clientes/ClientesRequest";

//************** Componentes Especificos **************/
import ModalClientesDetails from "./ModalClientesDetalles/ModalClientesDetails";
import ModalClientes from "./ModalClientes/ModalClientes";
import ConvenioCRUD from './ModalClientes/ConvenioCRUD'
import ModalFacturasCliente from "./ModalClientes/ModalFacturasCliente";
import ModalCierreClientes from "./CierreClientes/ModalCierreClientes";

import { AuthContext } from "../../Context/AuthContext/AuthContext";
import { setTitlePage } from "../../Services/Config/ConfigService";
import { CorreoInscripcion } from "./CorreoInscripcion";
import { getCorreosCliente } from "../../../API/Global/Email/EmailRequest";
import { sendEmailInscripcionCliente } from "../../API/Email/EmailRequest";
import { toastShow } from "../../Services/ToastService";
import { getLabel } from "../../Services/Language/LanguageService";
import { InscripcionClientesLang } from "./Lang/InscripcionClientesLang";
import { downloadFile } from "../../Services/ArchivosService";
import { Dropdown } from "primereact/dropdown";
import { getEstadosCategoryIPS } from "../../API/Global/Estados/StatusRequest";
import ReusableDialog from "../../Components/Dialog/ReusableDialog";

const ClientesScreen = (Finanzas = false) => {

  const Token = localStorage.getItem(process.env.REACT_APP_StorageToken);

  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const toast = useRef(null);
  const [data, setData] = useState([]);
  const [IdCustomer, setIdCustomer] = useState(0)
  const [NameCustomer, setNameCustomer] = useState('');
  const [showDialogInscripcion, setShowDialogInscripcion] = useState(false);
  const [proveedorMail, setProveedorMail] = useState({});
  const [idioma, setIdioma] = useState('es');
  const [correoAEviar, setCorreoAEviar] = useState([]);
  const [enlace, setEnlace] = useState('');
  const [loadingCorreo, setLoadingCorreo] = useState(false);
  const [correos, setCorreos] = useState('');
  const [clientesDetailsDialog, setClientesDetailsDialog] = useState(false);
  const [estados, setEstados] = useState([]);
  const [showConvenio, setShowConvenio] = useState(false);
  const [mostrarInactivos, setMostrarInactivos] = useState(false);
  const [mostrarOcultos, setMostrarOcultos] = useState(Finanzas?.Finanzas ? true : false);
  const { userAuth } = useContext(AuthContext);
  const [ocultarClientes, setOcultarClientes] = useState(Finanzas?.Finanzas ? false : userAuth.AccesosWeb.split(",").map((e) => parseInt(e)).includes(39));
  const [estadosRevision, setEstadosRevision] = useState([])

  const [clienteFacturasDialog, setClienteFacturasDialog] = useState(false);

  const [clientesDialog, setClientesDialog] = useState(false);
  const [selected, setSelected] = useState([])

  const getListadoClientes = async () => {
    setLoading(true)
    const result = await getCustomers();
    const envioCorreos = await getCorreosCliente(Token);
    const estadosClientes = await getEstadosCategoryIPS('Customer');
    setEstados(estadosClientes.filter(e => [1, 2].includes(e.IdStatus)));
    setCorreos(envioCorreos);

    const tempoEstadosRevision = await getEstadosCategoryIPS("Revision Cliente");
    setEstadosRevision(tempoEstadosRevision)

    if (mostrarInactivos) {
      let nuevaData = result
      setData(Finanzas?.Finanzas ? nuevaData : nuevaData.filter(i => i.IsVarios === mostrarOcultos || !i?.IsVarios))
    } else {
      let nuevaData = result?.filter(i => i?.IdStatus === 1)
      setData(Finanzas?.Finanzas ? nuevaData : nuevaData.filter(i => i.IsVarios === mostrarOcultos || !i?.IsVarios))
    }
    setLoading(false)
    setChecked(result.ActivoWeb)
  }

  const ChangeEstadoEdicion = (IdCustomer, Estado) => {
    updateEnlaceInscripcion({ IdCustomer, Estado });
    const tempo = data.map((item) => {
      if (item.IdCustomer === IdCustomer) {
        item.esEditable = Estado;
        toastShow(
          toast,
          "success",
          "Se actualizó el estado de edición del enlace de inscripción del cliente"
        );
      }
      return item;
    });
    setData(tempo);
  };

  const OcultarCliente = (IdCustomer, Estado) => {
    confirmDialog({
      message: '¿Está seguro que desea ocultar el cliente?',
      header: 'Confirmación',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        setLoading(true)
        ocultarClienteVentas({ IdCustomer, Estado });
        setTimeout(() => {
          toastShow(toast, "success", "Se ocultó el estado de edición del enlace de inscripción del cliente");
          setLoading(false)
          getInfoCliente()
          // setData((prevData) => prevData.filter(cliente => cliente.IdCustomer !== IdCustomer));
        }, 700);
      },
      reject: reject
    });


  };

  const ChangeClienteNuevo = (IdCustomer, Nuevo) => {
    updateClienteNuevo({ IdCustomer, Nuevo });
    const tempo = data.map((item) => {
      if (item.IdCustomer === IdCustomer) {
        item.esEditable = Nuevo;
        toastShow(
          toast,
          "success",
          "Acción realizada correctamente"
        );
      }
      return item;
    });
    setData(tempo);
    getListadoClientes()
  };

  const ChangeEstadoEdicionSinToast = (IdCustomer, Estado) => {
    updateEnlaceInscripcion({ IdCustomer, Estado });
    const tempo = data.map((item) => {
      if (item.IdCustomer === IdCustomer) {
        item.esEditable = Estado;
      }
      return item;
    });
    setData(tempo);
  };

  const openModalClientes = (Id) => {
    setClientesDialog(true)
    setIdCustomer(Id)
  }

  const openModalFacturasCliente = (Id, Nombre) => {
    setClienteFacturasDialog(true)
    setIdCustomer(Id)
    setNameCustomer(Nombre)
  }

  const hideDialogFacturasCliente = () => {
    setClienteFacturasDialog(false)
  }

  const reject = () => {
    toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
  }

  const cambiarEstado = async (checkValores, IdCustomer) => {

    setLoading(true)
    const result = await putChecksCustomer(checkValores)
    // const temporal = result.map((item) => {
    //     if (item.id === IdCustomer) {
    //         item.IsShipTo = true
    //     }
    //     return item
    // })

    // if (checkValores.Valor === 4) {
    //     let datosBlock = {
    //         IdCustomer: checkValores.IdCustomer,
    //         Block: checkValores.Activo === true ? 1 : 0,
    //         isFin: true
    //     }


    // const resultado = await BlockCustomerIPS(datosBlock)
    // }

    // let datosBlock = {
    //     IdCustomer: checkValores.IdCustomer,
    //     Block: checkValores.Activo === true ? 1 : 0,
    //     isFin: true
    // }
    // const resultado = await BlockCustomerIPS(datosBlock)

    setData(result)
    setLoading(false)

  }

  const onChangeCheck = async (valor, IdCustomer, e) => {
    let checkValores = {
      Valor: valor,
      Activo: e,
      IdCustomer: IdCustomer
    }

    if (valor === 3 || valor === 4) {
      confirmDialog({
        message: '¿Está seguro que desea cambiar el estado del cliente?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => cambiarEstado(checkValores, IdCustomer),
        reject: reject
      });
    }
    else {
      cambiarEstado(checkValores, IdCustomer)
    }
  }

  const changeIdioma = (e) => {
    setIdioma(e.value);
    if (e.value === null) {
      setIdioma("en");
    }
  };

  const setLabel = (label) => {
    return getLabel(InscripcionClientesLang, label, idioma);
  };

  const EnviarCorreoInscripcion = async () => {
    setLoadingCorreo(true);

    ChangeEstadoEdicionSinToast(proveedorMail.IdCustomer, true);

    if (enlace?.enlace) {
      const toEmails = [correoAEviar?.toString(), correos[0]?.DestinatariosMail].join(',');


      let htmlNuevoES =
        `<div style="font-size: 14px">
          <span><strong>Estimado Cliente: ${proveedorMail?.CustomerName}</strong></span><br/><br/>
          <p>
            Es un placer darle una cordial bienvenida como nuestro nuevo socio comercial.<br />
            <strong>Agradecemos su colaboración en este importante paso y esperamos trabajar juntos en un futuro exitoso.</strong>
          </p>

          <p>Para formalizar la inscripción, le solicitamos proceder con los siguientes pasos:<br>
            1. Complete el formulario en línea disponible en el siguiente enlace: 
            <a href="${process.env.REACT_APP_WERE_URL}/inscripcionClientes/${idioma}/${enlace?.enlace}" target="_blank">Haz click aquí para ingresar al formulario</a><br/>
            2. Adjunte los documentos requeridos, <strong>considere verificar que sean claros y legibles para evitar demoras en el proceso de validación.</strong><br/>
            3. Se adjunta el <strong>Manual de inscripción</strong> para su referencia.
          </p>

          <p>Si tiene alguna consulta o requiere asistencia, no dude en comunicarse con nosotros a través de su agente de servicio al cliente o del correo electrónico administracion@ppf.com.hn.<br/>
          Confiamos en que esta alianza será altamente beneficiosa y productiva para ambas partes.
          </p>

          <p>Saludos Cordiales.</p>
        </div>`;

      let htmlNuevoEN =
        `<div style="font-size: 14px">
          <span><strong>Dear Customer: ${proveedorMail?.CustomerName}</strong></span><br/><br/>
          <p>
            It is a pleasure to warmly welcome you as our new business partner.<br />
            <strong>We appreciate your collaboration in this important step and look forward to working together towards a successful future.</strong>
          </p>

          <p>To formalize the registration, please follow these steps:<br>
            1. Complete the online form available at the following link: 
            <a href="${process.env.REACT_APP_WERE_URL}/inscripcionClientes/${idioma}/${enlace?.enlace}" target="_blank">Click here to access the form</a><br/>
            2. Attach the required documents. <strong>Please ensure they are clear and legible to avoid delays in the validation process.</strong><br/>
            3. The <strong>Registration Manual</strong> is attached for your reference.
          </p>

          <p>If you have any questions or need assistance, feel free to contact us through your customer service agent or via email at administracion@ppf.com.hn.<br/>
          We trust that this partnership will be highly beneficial and productive for both parties.
          </p>

          <p>Best regards.</p>
        </div>`;


      let htmlES =
        `<div style="font-size: 14px">
          <span><strong>Estimado Cliente: ${proveedorMail?.CustomerName}</strong></span><br/><br/>
          <p>
            Esperamos que se encuentren bien. <br/>
            Como parte de nuestro compromiso por brindarle un mejor servicio, le solicitamos amablemente que actualice su información en nuestro sistema.
          </p>

          <p>Para ello, le solicitamos proceder con los siguientes pasos:<br>
            1. Complete el formulario en línea disponible en el siguiente enlace: 
            <a href="${process.env.REACT_APP_WERE_URL}/inscripcionClientes/${idioma}/${enlace?.enlace}" target="_blank">Haz click aquí para ingresar al formulario</a><br/>
            2. Adjunte los documentos requeridos, <strong>considere verificar que sean claros y legibles para evitar demoras en el proceso de validación.</strong><br/>
            3. Se adjunta el <strong>Manual de inscripción</strong> para su referencia.
          </p>

          <p>Si tiene alguna consulta o requiere asistencia, no dude en comunicarse con nosotros a través de su agente de servicio al cliente o del correo electrónico administracion@ppf.com.hn.<br/>
            Apreciamos sinceramente su colaboración en este proceso y confiamos en que nuestra alianza seguirá prosperando, generando valor y beneficios mutuos.
          </p>

          <p>Saludos Cordiales.</p>
        </div>`;


      let htmlEN =
        `<div style="font-size: 14px">
          <span><strong>Dear Customer: ${proveedorMail?.CustomerName}</strong></span><br/><br/>
          <p>
            We hope this email finds you well.<br/>
           As part of our commitment to providing you with better service and products, we kindly request you to update your information in our system.
          </p>
      
          <p>Please follow these steps:<br>
            1. Complete the online form through the link: 
            <a href="${process.env.REACT_APP_WERE_URL}/inscripcionClientes/${idioma}/${enlace?.enlace}" target="_blank">Click here to access the form</a><br/>
            2. Attach the required documents. <strong>Please make sure that the documents are clear and legible.</strong><br/>
            3. The <strong>Registration Manual</strong> is attached for your reference.
          </p>
      
          <p>If you have any questions or need further assistance, feel free to contact your customer service agent or by email at administracion@ppf.com.hn.<br/>
            We sincerely appreciate your cooperation in this process and trust that our partnership will continue to thrive, generating mutual value and benefits
          </p>
      
          <p>Best regards.</p>
        </div>`;


      let AsuntoESnuevo = 'Formulario de inscripción – Acción Requerida'
      let AsuntoENnuevo = 'Registration Form – Action Required'
      let AsuntoES = 'Actualización de Información – Acción Requerida'
      let AsuntoEN = 'Information Update – Action Required'

      let ClienteNuevo = proveedorMail?.Nuevo
      let objeto

      if (ClienteNuevo) {
        objeto = {
          to: toEmails,
          cc: correos[0].CCMail + ',' + userAuth?.Mail,
          bcc: correos[0].CCoMail,
          // to: 'lchinchilla@ppf.com.hn',
          subject: idioma === 'es' ? AsuntoESnuevo : AsuntoENnuevo,
          html: idioma === 'es' ? htmlNuevoES : htmlNuevoEN,
          idioma: idioma,
        };
      } else {
        objeto = {
          to: toEmails,
          cc: correos[0].CCMail + ',' + userAuth?.Mail,
          bcc: correos[0].CCoMail,
          // to: 'lchinchilla@ppf.com.hn',
          subject: idioma === 'es' ? AsuntoES : AsuntoEN,
          html: idioma === 'es' ? htmlES : htmlEN,
          idioma: idioma,
        };
      }


      const result = await sendEmailInscripcionCliente(objeto);
      if (result) {
        toastShow(toast, "success", "Correo enviado exitosamente.");
      } else {
        toastShow(toast, "error", "Correo no enviado.");
      }

      setTimeout(async () => {
        setProveedorMail(undefined);
        setLoadingCorreo(false);
        setShowDialogInscripcion(false);
      }, 1300);
    }
  };

  const handleButtonClick = () => {
    window.open(`${process.env.REACT_APP_WERE_URL}/inscripcionClientes/${idioma}/${enlace?.enlace}`, '_blank');
  };


  const getArchivo = async (rowData) => {
    const a = await descargarArchivoBIC(rowData?.CodigoCliente, rowData?.FileBIC, Token);
    downloadFile(a, rowData?.FileBIC);
  };

  const getArchivoFactura = async (rowData) => {
    const a = await descargarArchivoFactura(rowData?.CodigoCliente, rowData?.FileFactura, Token);
    downloadFile(a, rowData?.FileFactura);
  };

  const getArchivoPermiso = async (rowData) => {
    const a = await descargarArchivoPermiso(rowData?.CodigoCliente, rowData?.FilePermisoOpera, Token);
    downloadFile(a, rowData?.FilePermisoOpera);
  };

  const getArchivoEscritura = async (rowData) => {
    const a = await descargarArchivoEscritura(rowData?.CodigoCliente, rowData?.FileConstitucion, Token);
    downloadFile(a, rowData?.FileConstitucion);
  };

  const getArchivoConstancia = async (rowData) => {
    const a = await descargarArchivoConstancia(rowData?.CodigoCliente, rowData?.FileConstanciaPagosCuenta, Token);
    downloadFile(a, rowData?.FileConstanciaPagosCuenta);
  };

  const getArchivoRegistro = async (rowData) => {
    const a = await descargarArchivoRegistro(rowData?.CodigoCliente, rowData?.FileRegistroExonerado, Token);
    downloadFile(a, rowData?.FileRegistroExonerado);
  };

  const getArchivoEstados = async (rowData) => {
    const a = await descargarArchivoEstados(rowData?.CodigoCliente, rowData?.FileEstadosFinancieros, Token);
    downloadFile(a, rowData?.FileEstadosFinancieros);
  };

  const getArchivoRepresentante = async (rowData) => {
    const a = await descargarArchivoRepresentante(rowData?.CodigoCliente, rowData?.FileRepresentante, Token);
    downloadFile(a, rowData?.FileRepresentante);
  };

  const getArchivoRefComercial1 = async (rowData) => {
    const a = await descargarArchivoRefComercial1(rowData?.CodigoCliente, rowData?.FileRefComercial1, Token);
    downloadFile(a, rowData?.FileRefComercial1);
  }


  const getArchivoRefComercial2 = async (rowData) => {
    const a = await descargarArchivoRefComercial2(rowData?.CodigoCliente, rowData?.FileRefComercial2, Token);
    downloadFile(a, rowData?.FileRefComercial2);
  }

  const getArchivoRefBan1 = async (rowData) => {
    const a = await descargarArchivoRefBan1(rowData?.CodigoCliente, rowData?.FileRefBanc1, Token);
    downloadFile(a, rowData?.FileRefBanc1);
  }

  const getArchivoRefBan2 = async (rowData) => {
    const a = await descargarArchivoRefBan2(rowData?.CodigoCliente, rowData?.FileRefBanc2, Token);
    downloadFile(a, rowData?.FileRefBanc2);
  }


  const getArchivoCertificadoA = async (rowData) => {
    const a = await descargarArchivoCertificadoA(rowData?.CodigoCliente, rowData?.FileCertificadoAmbiental, Token);
    downloadFile(a, rowData?.FileCertificadoAmbiental);
  }

  const getArchivoCertificadoL = async (rowData) => {
    const a = await descargarArchivoCertificadoL(rowData?.CodigoCliente, rowData?.FileCertificadoLaboral, Token);
    downloadFile(a, rowData?.FileCertificadoLaboral);
  }

  const getArchivoFormatoInscripcion = async (rowData) => {
    const a = await descargarArchivoFormatoInscripcion(rowData?.CodigoCliente, rowData?.FileFormatoInscripcion, Token);
    downloadFile(a, rowData?.FileFormatoInscripcion);
  }

  const cambiarEstadoCliente = async (IdEstado, IdCustomers) => {
    const result = await postChangeEstadoClientes({ IdEstado, IdCustomers });
    toastShow(toast, "success", "Estado cambiado exitosamente");
    // if(result){
    // }
    // else{
    //   toastShow(toast, "error", "Error al cambiar estado");
    // }
  }

  const changeEstado = ({ data, api }) => {
    return <div>
      <Dropdown
        value={estados.filter(e => e.IdStatus === data.IdEstado)[0]}
        options={estados}
        optionLabel="StatusName"
        filter
        filterBy="StatusName"
        style={{ width: '100%' }}
        onChange={(e) => {
          let changes = []
          if (selected.length > 0) {
            changes = selected.map(item => {
              return {
                IdCustomer: item.IdCustomer,
                IdStatus: e.value.IdStatus,
                StatusName: e.value.StatusName
              }
            })
          }
          else {
            changes.push({
              IdCustomer: data.IdCustomer,
              IdStatus: e.value.IdStatus,
              StatusName: e.value.StatusName
            })
          }
          confirmDialog({
            message: `¿Cambiar a estado ${e.value.StatusName} a ${changes.length} Proveedores ?`,
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: async () => {
              let IdClientes = changes.map(item => item.IdCustomer);
              cambiarEstadoCliente(e.value.IdStatus, IdClientes.toString());
              getListadoClientes();
              api.stopEditing();
            },
            reject: () => {
              getListadoClientes();
            }
          })
        }}
      />
    </div>
  }
  const CambiarEstadoRevisado = async (datos, api) => {
    if (datos) {
      const result = await CambiarEstadoInscripcion(datos, Token)
      if (result?.length > 0) {
        if (result[0]?.ESTADO === 1) {
          toastShow(toast, 'success', 'Estado Actualizado Correctamente')
          setTimeout(() => {
            getListadoClientes();
            api.stopEditing();
          }, 600);
        } else {
          toastShow(toast, 'error', result[0]?.MENSAJE)
          getListadoClientes();
        }
      }
    }


  }

  const changeEstadoRevisado = ({ data, api }) => {
    let rowData = data
    return <div>
      <Dropdown
        value={estadosRevision?.filter(e => e.IdStatus === rowData?.IdEstadoRevisado)[0]}
        options={estadosRevision}
        optionLabel="StatusName"
        filter
        filterBy="StatusName"
        style={{ width: '100%' }}
        onChange={(e) => {
          let datosEnviar = []
          if (selected.length > 0) {
            datosEnviar = selected?.filter(f => f.IdRegistro > 0)?.map(s => {
              return {
                ...s,
                IdEstadoRevisado: e?.value?.IdStatus,
                EstadoRevisado: e?.value?.StatusName
              }
            })
          }
          else {
            if (rowData?.IdRegistro > 0) {
              datosEnviar.push({
                ...rowData,
                IdEstadoRevisado: e?.value?.IdStatus,
                EstadoRevisado: e?.value?.StatusName
              })

            }
          }
        
          if (datosEnviar?.length > 0) {
            confirmDialog({
              message: `¿Cambiar a estado ${e?.value?.StatusName} a ${datosEnviar?.length} Clientes ?`,
              header: 'Confirmación',
              icon: 'pi pi-exclamation-triangle',
              accept: async () => {
                CambiarEstadoRevisado(datosEnviar, api)
              },
              reject: () => {
                getListadoClientes();
              }
            })
          } else {
            toastShow(toast, 'error', 'Los Clientes seleccionados no cuentan con una inscripción')
          }
        }}

      />
    </div>
  }

  const table = {
    Data: data,
    Columns: [
      //GENERAL
      {
        headerName: "Información General",
        headerNameEn: "General Information",
        children: [
          {
            field: 'IdCustomer',
            header: 'ID',
            className: 'XXsmall',
            hidden: userAuth.IdRol === 1
          },
          {
            field: 'DateCreate',
            headerEn: 'Date Create',
            header: 'Fecha Creado',
            className: 'medium',
            Format: 'Date',
            align: "Center"
          },
          {
            header: "Estado",
            headerEn: "Status",
            field: "IdStatus",
            className: "Xsmall",
            Format: "Estado",
            // filter: false,
            cellEditor: changeEstado,
            body: (rowData) => ({ ID: rowData.StatusName, Estado: rowData.StatusName }),
            editable: [1, 6, 17].includes(userAuth.IdRol),
          },
          {
            field: 'CodigoCliente',
            header: 'Código',
            headerEn: 'Code',
            className: 'small',
            Format: 'Modal',
            Sumary: 'count'
          },
          {
            field: 'CustomerName',
            header: 'Compañia',
            headerEn: 'Company',
            className: 'Xlarge',
          },
          {
            field: 'Abreviacion',
            header: 'Abreviación',
            headerEn: 'Abbreviation',
            className: 'small',
            align: "center",
          },
          {
            field: 'RTN',
            header: 'RTN',
            className: 'small',
          },
          {
            field: 'TipoPagoCliente',
            header: 'Tipo de Pago Clientes',
            headerEn: 'Customer payment type',
            className: 'medium',
          },
          {
            field: 'NombreTipoPago',
            header: 'Tipo Pago',
            headerEn: 'Payment Type',
            className: 'small',
          },
          {
            field: 'CreditLimit',
            header: 'Límite de crédito',
            headerEn: 'Credit Limit',
            className: 'small',
            Format: 'Currency',
          },
          {
            field: 'TermName',
            header: 'Términos',
            headerEn: 'Payment',
            className: 'medium',
          },
          {
            field: 'TermFreightName',
            header: 'Términos Flete',
            headerEn: 'Freight Terms',
            className: 'medium',
          },
          {
            field: 'Email',
            header: 'Correo',
            headerEn: 'Email',
            className: 'medium',
          },
          {
            field: 'Address',
            headerEn: 'Address',
            header: 'Dirección',
            className: 'large',
          },
          {
            field: 'CountryName',
            header: 'Pais',
            headerEn: 'Country',
            className: 'medium',
          },

          // Nuevas columnas añadidas
          {
            field: 'PrincipalActividadEconomica',
            header: 'Actividad Económica',
            headerEn: 'Economic Activity',
            className: 'medium',
          },
          {
            field: 'CasaMatriz',
            header: 'Casa Matriz',
            headerEn: 'Headquarters',
            className: 'medium',
          },
          {
            field: 'DireccionCasaMatriz',
            header: 'Dirección Casa Matriz',
            headerEn: 'Headquarters Address',
            className: 'medium',
          },
          {
            field: 'BilledToAddress',
            header: 'Dirección de Facturación',
            headerEn: 'Invoices to be Billed To',
            className: 'medium',
          },
        ]
      },
      {
        field: 'PorcentajePenalizacion',
        header: '% Penalización',
        headerEn: 'Penalty %',
        className: 'medium',
      },

      //Representante
      {
        headerName: 'Representante Legal',
        headerNameEn: 'Legal Representative',
        children: [
          {
            field: 'NombreRepresentanteLegal',
            header: 'Nombre',
            headerEn: 'Name',
            className: 'medium',
          },
          {
            field: 'IdentificacionRepresentante',
            header: 'Identificación',
            headerEn: 'Identification',
            className: 'medium',
          },
          {
            field: 'TelefonoRepresentante',
            header: 'Teléfono',
            headerEn: 'Phone',
            className: 'medium',
          },
          {
            field: 'CorreoRepresentanteLegal',
            header: 'Correo',
            headerEn: 'Email',
            className: 'medium',
          },
          {
            field: 'FileRepresentante',
            header: 'Archivo ID',
            headerEn: 'File ID',
            className: 'large',
          },
          {
            field: '',
            filter: false,
            header: '',
            className: 'XXsmall',
            Format: 'Template',
            body: (rowData) => (
              rowData.FileRepresentante ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Button
                    icon="pi pi-download"
                    className="p-button-text"
                    onClick={() => getArchivoRepresentante(rowData)}
                    tooltip="Identificación Representante"
                    tooltipOptions={{
                      position: "top",
                    }}
                  />
                </div>
              ) : ('')

            )
          },
        ]
      },

      //Cuentas por Pagar
      {
        headerName: 'Cuentas por Pagar',
        headerNameEn: 'Accounts Payable',
        children: [
          {
            field: 'ContactoCuentasPorPagar',
            header: 'Nombre',
            headerEn: 'Name',
            className: 'medium',
          },
          {
            field: 'CorreoCuentasPorPagar',
            header: 'Correo',
            headerEn: 'Email',
            className: 'medium',
          },
          {
            field: 'TelefonoCuentasPorPagar',
            header: 'Teléfono',
            headerEn: 'Phone',
            className: 'medium',
          }
        ]
      },

      //Contacto Finanzas
      {
        headerName: "Contacto Finanzas",
        headerNameEn: "Contact Finance",
        children: [
          {
            field: 'NombreContactoFin1',
            header: 'Nombre',
            headerEn: 'Name',
            className: 'medium',
          },
          {
            field: 'CorreoContactoFin1',
            header: 'Correo',
            header: 'Email',
            className: 'medium',
          },
          {
            field: 'TelefonoContactoFin1',
            header: 'Teléfono',
            headerEn: 'Phone',
            className: 'medium',
          },
          // {
          //   field: 'NombreContactoFin2',
          //   header: 'Nombre Contacto Fin 2',
          //   className: 'medium',
          // },
          // {
          //   field: 'CorreoContactoFin2',
          //   header: 'Correo Contacto Fin 2',
          //   className: 'medium',
          // },
          // {
          //   field: 'TelefonoContactoFin2',
          //   header: 'Telefono Contacto Fin 2',
          //   className: 'medium',
          // }
        ]
      },

      //Referencias Comerciales
      {
        headerName: "Referencias Comerciales",
        children: [
          {
            field: 'CompanyRefComercial1',
            header: 'Nombre de Compañía',
            headerEn: 'Comany Name',
            className: 'medium',
          },
          {
            field: 'RefNombre1',
            header: 'Nombre 1',
            headerEn: 'Name 1',
            className: 'medium',
          },
          {
            field: 'RefCorreo1',
            header: 'Referencia Correo 1',
            className: 'medium',
          },
          {
            field: 'RefTelefono1',
            header: 'Telefono 1',
            headerEn: 'Phone 1',
            className: 'medium',
          },
          {
            field: 'FileRefComercial1',
            header: 'Archivo Ref 1',
            headerEn: 'File Ref 1',
            className: 'large',
          },
          {
            field: '',
            filter: false,
            header: '',
            className: 'XXsmall',
            Format: 'Template',
            body: (rowData) => (
              rowData.FileRefComercial1 ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Button
                    icon="pi pi-download"
                    className="p-button-text"
                    onClick={() => getArchivoRefComercial1(rowData)}
                    tooltip="Archivo Ref. Comercial 1"
                    tooltipOptions={{
                      position: "top",
                    }}
                  />
                </div>
              ) : ('')

            )
          },
          {
            field: 'CompanyRefComercial2',
            header: 'Nombre de Compañía',
            headerEn: 'Comany Name',
            className: 'medium',
          },
          {
            field: 'RefNombre2',
            header: 'Nombre 2',
            headerEn: 'Name 2',
            className: 'medium',
          },
          {
            field: 'RefCorreo2',
            header: 'Correo 2',
            header: 'Email 2',
            className: 'medium',
          },
          {
            field: 'RefTelefono2',
            header: 'Telefono 2',
            headerEn: 'Phone 2',
            className: 'medium',
          },
          {
            field: 'FileRefComercial2',
            header: 'Archivo Ref 2',
            headerEn: 'File Ref 2',
            className: 'large',
          },
          {
            field: '',
            filter: false,
            header: '',
            className: 'XXsmall',
            Format: 'Template',
            body: (rowData) => (
              rowData.FileRefComercial2 ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Button
                    icon="pi pi-download"
                    className="p-button-text"
                    onClick={() => getArchivoRefComercial2(rowData)}
                    tooltip="Archivo Ref. Comercial 1"
                    tooltipOptions={{
                      position: "top",
                    }}
                  />
                </div>
              ) : ('')

            )
          },
          // {
          //   field: 'RefNombre3',
          //   header: 'Referencia Nombre 3',
          //   className: 'medium',
          // },
          // {
          //   field: 'RefCorreo3',
          //   header: 'Referencia Correo 3',
          //   className: 'medium',
          // },
          // {
          //   field: 'RefTelefono3',
          //   header: 'Referencia Telefono 3',
          //   className: 'medium',
          // }
        ]
      },

      //Referencias Bancarias
      {
        headerName: "Referencias Bancarias",
        headerNameEn: "Bank References",
        children: [
          {
            field: 'BankName1',
            header: 'Nombre Banco 1',
            headerEn: 'Bank Name 1',
            className: 'medium',
          },
          {
            field: 'NombreRefBancaria1',
            header: 'Nombre 1',
            headerEn: 'Name 1',
            className: 'medium',
          },
          {
            field: 'TelefonoRefBancaria1',
            header: 'Teléfono 1',
            headerEn: 'Phone 1',
            className: 'medium',
          },
          {
            field: 'CorreoRefBancaria1',
            header: 'Correo Ref. 1',
            headerEn: 'Email Ref. 1',
            className: 'medium',
          },
          {
            field: 'FileRefBanc1',
            header: 'Archivo Ref 1',
            headerEn: 'File Ref 1',
            className: 'large',
          },
          {
            field: '',
            filter: false,
            header: '',
            className: 'XXsmall',
            Format: 'Template',
            body: (rowData) => (
              rowData.FileRefBanc1 ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Button
                    icon="pi pi-download"
                    className="p-button-text"
                    onClick={() => getArchivoRefBan1(rowData)}
                    tooltip="Archivo Ref. Bancaria 1"
                    tooltipOptions={{
                      position: "top",
                    }}
                  />
                </div>
              ) : ('')

            )
          },

          {
            field: 'BankName2',
            headerEn: 'Bank Name 2',
            header: 'Nombre Banco 2',
            className: 'medium',
          },
          {
            field: 'NombreRefBancaria2',
            header: 'Nombre 2',
            headerEn: 'Name 2',
            className: 'medium',
          },
          {
            field: 'TelefonoRefBancaria2',
            header: 'Teléfono 2',
            headerEn: 'Phone 2',
            className: 'medium',
          },
          {
            field: 'CorreoRefBancaria2',
            header: 'Correo Ref. 2',
            headerEn: 'Email Ref. 2',
            className: 'medium',
          },
          {
            field: 'FileRefBanc2',
            header: 'Archivo Ref 2',
            headerEn: 'File Ref 2',
            className: 'large',
          },
          {
            field: '',
            filter: false,
            header: '',
            className: 'XXsmall',
            Format: 'Template',
            body: (rowData) => (
              rowData.FileRefBanc2 ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Button
                    icon="pi pi-download"
                    className="p-button-text"
                    onClick={() => getArchivoRefBan2(rowData)}
                    tooltip="Archivo Ref. Bancaria 2"
                    tooltipOptions={{
                      position: "top",
                    }}
                  />
                </div>
              ) : ('')

            )
          },

        ]
      },

      //Documentacion
      {
        headerName: "Archivos",
        headerNameEn: "Files",
        children: [
          {
            field: 'FileBIC',
            header: 'Archivo BIC',
            headerEn: 'File BIC',
            className: 'large',
          },
          {
            field: '',
            filter: false,
            header: '',
            className: 'XXsmall',
            Format: 'Template',
            body: (rowData) => (
              rowData.FileBIC ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Button
                    icon="pi pi-download"
                    className="p-button-text"
                    onClick={() => getArchivo(rowData)}
                    tooltip="Descargar BIC"
                    tooltipOptions={{
                      position: "top",
                    }}
                  />
                </div>
              ) : ('')

            )
          },
          {
            field: 'FileFactura',
            header: 'Archivo Factura',
            headerEn: 'File Invoice',
            className: 'medium',
          },
          {
            field: '',
            filter: false,
            header: '',
            className: 'XXsmall',
            Format: 'Template',
            body: (rowData) => (
              rowData.FileFactura ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Button
                    icon="pi pi-download"
                    className="p-button-text"
                    onClick={() => getArchivoFactura(rowData)}
                    tooltip="Descargar Factura"
                    tooltipOptions={{
                      position: "top",
                    }}
                  />
                </div>
              ) : ('')
            )
          },
          {
            field: 'FilePermisoOpera',
            header: 'Archivo Permiso Operación',
            headerEn: 'File Operation Permission',
            className: 'medium',
          },
          {
            field: '',
            filter: false,
            header: '',
            className: 'XXsmall',
            Format: 'Template',
            body: (rowData) => (
              rowData.FilePermisoOpera ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Button
                    icon="pi pi-download"
                    className="p-button-text"
                    onClick={() => getArchivoPermiso(rowData)}
                    tooltip="Descargar Permiso"
                    tooltipOptions={{
                      position: "top",
                    }}
                  />
                </div>
              ) : ('')
            )
          },
          {
            field: 'FileConstitucion',
            header: 'Archivo Constitución',
            headerEn: 'Constitution Archive',
            className: 'medium',
          },
          {
            field: '',
            filter: false,
            header: '',
            className: 'XXsmall',
            Format: 'Template',
            body: (rowData) => (
              rowData.FileConstitucion ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Button
                    icon="pi pi-download"
                    className="p-button-text"
                    onClick={() => getArchivoEscritura(rowData)}
                    tooltip="Descargar Escritura"
                    tooltipOptions={{
                      position: "top",
                    }}
                  />
                </div>
              ) : ('')
            )
          },
          // {
          //   field: 'FileConstanciaPagosCuenta',
          //   header: 'Archivo Constancia Pagos Cuenta',
          //   headerEn: 'Record of Account Payments File',
          //   className: 'medium',
          // },
          // {
          //   field: '',
          //   filter: false,
          //   header: '',
          //   className: 'XXsmall',
          //   Format: 'Template',
          //   body: (rowData) => (
          //     rowData.FileConstitucion ? (
          //       <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          //           <Button
          //               icon="pi pi-download"
          //               className="p-button-text"
          //               onClick={() => getArchivoConstancia(rowData)}
          //               tooltip="Descargar Constancia"
          //               tooltipOptions={{
          //                   position: "top",
          //                 }}
          //           />
          //       </div>
          //     ) : ('')
          //   )
          // },
          {
            field: 'FileRegistroExonerado',
            header: 'Archivo Registro Exonerado',
            headerEn: 'Exonerated Registry File',
            className: 'medium',
          },
          {
            field: '',
            filter: false,
            header: '',
            className: 'XXsmall',
            Format: 'Template',
            body: (rowData) => (
              rowData.FileRegistroExonerado ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Button
                    icon="pi pi-download"
                    className="p-button-text"
                    onClick={() => getArchivoRegistro(rowData)}
                    tooltip="Descargar Registro Exónerado"
                    tooltipOptions={{
                      position: "top",
                    }}
                  />
                </div>
              ) : ('')
            )
          },
          {
            field: 'FileEstadosFinancieros',
            header: 'Archivo Estados Financieros',
            headerEn: 'Financial Statements File',
            className: 'medium',
          },
          {
            field: '',
            filter: false,
            header: '',
            className: 'XXsmall',
            Format: 'Template',
            body: (rowData) => (
              rowData.FileEstadosFinancieros ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Button
                    icon="pi pi-download"
                    className="p-button-text"
                    onClick={() => getArchivoEstados(rowData)}
                    tooltip="Descargar Estados Financieros"
                    tooltipOptions={{
                      position: "top",
                    }}
                  />
                </div>
              ) : ('')
            )
          },
          {
            field: 'FileCertificadoAmbiental',
            header: 'Certificado Ambiental',
            headerEn: 'File Invoice',
            className: 'medium',
          },
          {
            field: '',
            filter: false,
            header: '',
            className: 'XXsmall',
            Format: 'Template',
            body: (rowData) => (
              rowData.FileCertificadoAmbiental ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Button
                    icon="pi pi-download"
                    className="p-button-text"
                    onClick={() => getArchivoCertificadoA(rowData)}
                    tooltip="Descargar Certificado"
                    tooltipOptions={{ position: "top" }}
                  />
                </div>
              ) : ('')
            )
          },
          {
            field: 'FileCertificadoLaboral',
            header: 'Certificado Laboral',
            headerEn: 'File Invoice',
            className: 'medium',
          },
          {
            field: '',
            filter: false,
            header: '',
            className: 'XXsmall',
            Format: 'Template',
            body: (rowData) => (
              rowData.FileCertificadoLaboral ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Button
                    icon="pi pi-download"
                    className="p-button-text"
                    onClick={() => getArchivoCertificadoL(rowData)}
                    tooltip="Descargar Certificado"
                    tooltipOptions={{ position: "top" }}
                  />
                </div>
              ) : ('')
            )
          },
        ]
      },

      //Zona Libre
      {
        headerName: "Zona Libre",
        headerNameEn: "Free Zone",
        children: [
          {
            field: 'ZonaLibre',
            header: 'Zona Libre',
            headerEn: 'Free Zone',
            className: 'small',
            Format: "Template",
            align: "center",
            filter: false,
            body: (rowData) => (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <Checkbox disabled checked={rowData.ZonaLibre} />
              </div>
            )
          },
          {
            field: 'NombreZonaLibre',
            header: 'Nombre Zona Libre',
            headerEn: 'Free Zone Name',
            className: 'medium',
          },
          {
            field: 'DireccionZonaLibre',
            header: 'Dirección Zona Libre',
            headerEn: 'Free Zone Address',
            className: 'medium',
          }
        ]
      },
      {
        field: 'Incompleta',
        header: 'Incompleta',
        filter: true,
        Format: 'Template',
        className: 'Xsmall',
        headerTooltip: 'Inscripción Incompleta',
        body: (rowData) => (
          <div className='d-flex flex-row' style={{ justifyContent: 'center' }}>
            <Checkbox
              checked={rowData.Incompleta}
              disabled
              tooltipOptions={{ position: "top" }}
            />
          </div>
        )
      },
      {
        field: 'IdEstadoRevisado',
        header: 'Estado Revisado',
        headerEn: 'Estado Revisado',
        className: 'small',
        Format: "Estado",
        // filter: false,
        cellEditor: changeEstadoRevisado,
        body: (rowData) => ({ ID: rowData.IdEstadoRevisado, Estado: rowData.EstadoRevisado }),
        editable: [1].includes(userAuth.IdRol),
      },
      {
        field: 'UsuarioFinanzas',
        header: 'Usuario Finanzas',
        headerEn: 'Finance User',
        className: 'small',
      },
      {
        field: 'UsuarioVentas',
        header: 'Usuario Ventas',
        headerEn: 'Sales User',
        className: 'small',
      },
      {
        field: '',
        header: 'Nuevo',
        headerEn: 'New',
        filter: false,
        alignFrozen: 'right',
        Format: 'Template',
        className: 'Xsmall',
        body: (rowData) => (
          <div className='d-flex flex-row' style={{ justifyContent: 'center' }}>
            <Checkbox
              checked={rowData.Nuevo}
              onChange={(e) => {
                if (rowData?.IdCustomer) {
                  ChangeClienteNuevo(rowData.IdCustomer, e.target.checked)
                }
              }
              }
              // disabled={!Finanzas?.Finanzas}
              tooltipOptions={{ position: "top" }}
              tooltip="Cliente Nuevo"
            />
          </div>
        )
      },
      //Checkbox
      {
        field: 'IsContado',
        header: 'IsContado',
        className: 'Xsmall',
        Format: "Template",
        align: "center",
        frozen: 'true',
        alignFrozen: 'right',
        filter: false,
        body: (rowData) => <Checkbox disabled onChange={(e) => rowData?.IdCustomer ? onChangeCheck(3, rowData.IdCustomer, e.checked) : null} style={{ marginBottom: 5 }} checked={rowData.IsContado} />,
      },
      {
        field: 'BlockFinanzas',
        header: 'BlockFinanzas',
        className: 'Xsmall',
        Format: "Template",
        align: "center",
        frozen: 'true',
        alignFrozen: 'right',
        filter: false,
        body: (rowData) => <Checkbox disabled={!Finanzas} onChange={(e) => rowData?.IdCustomer ? onChangeCheck(4, rowData.IdCustomer, e.checked) : null} style={{ marginBottom: 5 }} checked={rowData.BlockFinanzas} />,
      },

      ocultarClientes && (
        {
          field: 'IsVarios',
          header: 'Ocultar',
          headerEn: 'Hidden',
          filter: true,
          alignFrozen: 'right',
          Format: 'Template',
          className: 'Xsmall',
          body: (rowData) => (
            <div className='d-flex flex-row' style={{ justifyContent: 'center' }}>
              <Checkbox
                checked={rowData.IsVarios}
                onChange={(e) => {
                  if (rowData?.IdCustomer) {
                    OcultarCliente(rowData.IdCustomer, e.target.checked)
                  }
                }
                }
                tooltipOptions={{ position: "top" }}
                tooltip="Ocultar Cliente"
              />
            </div>
          )
        }
      ),


      Finanzas.Finanzas ?
        {
          field: "IdCustomer",
          header: "",
          Format: "Botones",
          filter: false,
          alignFrozen: "right",
          frozen: true,
          Botones: [
            {
              icon: "pi pi-pencil",
              tooltip: "Editar",
              onClick: (rowData) => {
                if (rowData?.IdCustomer) {
                  openModalClientes(rowData?.IdCustomer)
                }
              },
              tooltipOptions: {
                position: "top",
              },
            },
            {
              icon: "pi pi-dollar",
              tooltip: "Convenio",
              disabled: (rowData) => rowData?.IdTipoPagoCliente !== 2,
              onClick: (rowData) => {
                if (rowData?.IdCustomer) {
                  setSelected(rowData)
                  setShowConvenio(true)
                }
              },
              tooltipOptions: {
                position: "top",
              },
            },
            {
              icon: "ri-wallet-line",
              tooltip: "Facturas",
              onClick: (rowData) => {
                if (rowData?.IdCustomer) {
                  openModalFacturasCliente(
                    rowData.IdCustomer,
                    rowData.CustomerName)
                }
              },
              tooltipOptions: {
                position: "top",
              },
            },
            {
              icon: "pi pi-envelope",
              tooltip: "Enviar correo Inscripción",
              onClick: async (rowData) => {
                if (rowData?.IdCustomer) {
                  setShowDialogInscripcion(true);
                  setProveedorMail(rowData);
                  setCorreoAEviar(rowData?.Email === ' ' ? [] : [rowData?.Email]);
                  // const enlaceT = await getEnlaceInscripcion(rowData.IdCustomer);
                  let Fin = Finanzas?.Finanzas ? true : false
                  const enlaceT = await getEnlaceInscripcion(rowData.IdCustomer, userAuth?.idUser, Fin);
                  setEnlace({ enlace: enlaceT[0], Email: correoAEviar, CustomerName: rowData?.CustomerName })
                }
              },
              tooltipOptions: {
                position: "top",
              },
            },
            {
              icon: "ri-file-user-line",
              tooltip: "Compradores",
              onClick: (rowData) => {
                if (rowData?.IdCustomer) {
                  setIdCustomer(rowData.IdCustomer)
                  setClientesDetailsDialog(true)
                }
              },
              tooltipOptions: {
                position: "top",
              },
            },
          ],
        } :

        {
          field: "IdCustomer",
          header: "",
          Format: "Botones",
          filter: false,
          alignFrozen: "right",
          frozen: true,
          Botones: [
            {
              icon: "pi pi-pencil",
              tooltip: "Editar",
              onClick: (rowData) => {
                if (rowData?.IdCustomer) {
                  openModalClientes(rowData?.IdCustomer)
                }
              },
              tooltipOptions: {
                position: "top",
              },
            },
            {
              icon: "pi pi-envelope",
              tooltip: "Enviar correo Inscripción",
              onClick: async (rowData) => {
                if (rowData?.IdCustomer) {
                  setShowDialogInscripcion(true);
                  setProveedorMail(rowData);
                  setCorreoAEviar(rowData?.Email === ' ' ? [] : [rowData?.Email]);
                  // const enlaceT = await getEnlaceInscripcion(rowData.IdCustomer);

                  let Fin = Finanzas?.Finanzas ? true : false
                  const enlaceT = await getEnlaceInscripcion(rowData.IdCustomer, userAuth?.idUser, Fin);
                  setEnlace({ enlace: enlaceT[0], Email: correoAEviar, CustomerName: rowData?.CustomerName })
                }
              },
              tooltipOptions: {
                position: "top",
              },
            },
            {
              icon: "ri-file-user-line",
              tooltip: "Compradores",
              onClick: (rowData) => {
                if (rowData?.IdCustomer) {
                  setIdCustomer(rowData.IdCustomer)
                  setClientesDetailsDialog(true)
                }
              },
              tooltipOptions: {
                position: "top",
              },
            },
          ],
        },

      {
        field: '',
        header: '',
        headerEn: '',
        filter: false,
        alignFrozen: 'right',
        Format: 'Template',
        className: 'XXsmall',
        body: (rowData) => (
          <div className='d-flex flex-row' style={{ justifyContent: 'center' }}>
            <Checkbox
              checked={rowData.esEditable}
              onChange={(e) => {
                if (rowData?.IdCustomer) {
                  ChangeEstadoEdicion(rowData.IdCustomer, e.target.checked)
                }
              }
              }
              tooltipOptions={{ position: "top" }}
              tooltip="Habilitar inscripción"
            />
          </div>
        )
      },
      {
        field: 'IdCustomer',
        header: 'Formato de inscripción',
        headerEn: 'Formato',
        tooltip: '',
        Format: 'Botones',
        // alignFrozen: 'right',
        // frozen: true,
        className: 'small',
        Botones: [
          {},
          {
            icon: 'pi pi-download',
            tooltip: 'Descargar formato de inscripción de cliente',
            onClick: (rowData) => {
              console.log({ rowData });
              getArchivoFormatoInscripcion(rowData)
            },
            className: '',
            disabled: (rowData) => {
              return rowData?.FileFormatoInscripcion ? false : true
            },
          },
          {},
        ]
      },

      {
        field: "IdCustomer",
        header: "",
        Format: "SplitButton",
        filter: false,
        // className: 'Xsmall',
        alignFrozen: "right",
        frozen: true,
        Botones: [
          {
            icon: "pi pi-print",
            tooltip: "Formato de Inscripción",
            tooltipOptions: {
              position: "top",
            },
            onClick: async (rowData) => {
              if (rowData?.IdCustomer) {
                const Token = await getEnlaceInscripcion(rowData.IdCustomer);
                window.open(`${process.env.REACT_APP_WERE_URL}/FormatoInscripcionClientes/${rowData?.IdCustomer}/${Token}/2`, rowData?.IdCustomer, "MsgWindow", "height=1200,width=1000",)
              }
            },
            items: [
              {
                label: "Ingles",
                // icon: "pi pi-search",
                onClick: async (rowData) => {
                  if (rowData?.IdCustomer) {
                    const Token = await getEnlaceInscripcion(rowData.IdCustomer);
                    window.open(`${process.env.REACT_APP_WERE_URL}/FormatoInscripcionClientes/${rowData?.IdCustomer}/${Token}/1`, rowData?.IdCustomer, "MsgWindow", "height=1200,width=1000",)
                  }
                },
              },
              {
                label: "Español",
                // icon: "pi pi-trash",
                onClick: async (rowData) => {
                  if (rowData?.IdCustomer) {
                    const Token = await getEnlaceInscripcion(rowData.IdCustomer);
                    window.open(`${process.env.REACT_APP_WERE_URL}/FormatoInscripcionClientes/${rowData?.IdCustomer}/${Token}/2`, rowData?.IdCustomer, "MsgWindow", "height=1200,width=1000",)
                  }
                },
              },
            ],
          },
        ],
      },
    ],
    showModal: (e) => showModal(e),
    key: 'IdCustomer ',
    selected: selected,
    setSelected: setSelected,
  }

  const showModal = () => { };

  const toggleMostrarInactivos = () => {
    setMostrarInactivos(prevState => !prevState);
  };

  const toggleMostrarOcultos = () => {
    setMostrarOcultos(prevState => !prevState);
  };


  useEffect(() => {
    getListadoClientes();
    setTitlePage('Clientes')
  }, [])

  useEffect(() => {
    getListadoClientes();
  }, [mostrarInactivos, mostrarOcultos])


  return (
    <div>
      <Loader loading={loading} />
      <ConfirmDialog />
      <Card
        titulo={
          <div className="d-flex">
            <h3 className="mx-3">Clientes</h3>
            {/* <ModalClientes
                      toast={toast}
                      icono={aspectoBoton[0].Icono}
                      nombre={aspectoBoton[0].Nombre}
                      className={aspectoBoton[0].className}
                      getListadoClientes={getListadoClientes}
                  /> */}

            <Button
              icon="ri-restart-line"
              onClick={getListadoClientes}
            />
            <Button className='p-button-success mx-1' icon="pi pi-plus" loading={loading} onClick={() => setClientesDialog(true)} />

            <Button
              className='p-button-success mx-1'
              label={mostrarInactivos ? 'Ocultar Inactivos' : "Mostrar Inactivos"}
              onClick={() => toggleMostrarInactivos()}
            />

            {ocultarClientes && (
              <Button
                className='p-button-success mx-1'
                label={mostrarOcultos ? 'Ocultar Varios' : "Mostrar Varios"}
                onClick={() => toggleMostrarOcultos()}
              />
            )}

            {Finanzas.Finanzas === true && (
              <ModalCierreClientes />
            )}
          </div>
        }
        contenido={
          <div className="pt-4" style={{ height: "90vh" }}>
            <Toast position="bottom-right" ref={toast} />

            <AgGrid table={table} />
          </div>
        }
      />

      <ModalFacturasCliente
        clienteFacturasDialog={clienteFacturasDialog}
        setClienteFacturasDialog={setClienteFacturasDialog}
        hideDialogFacturasCliente={hideDialogFacturasCliente}
        IdCustomer={IdCustomer}
        CustomerName={NameCustomer}
      />

      <ModalClientes
        clientesDialog={clientesDialog}
        setClientesDialog={setClientesDialog}
        IdCustomer={IdCustomer}
        setIdCustomer={setIdCustomer}
        getListadoClientes={getListadoClientes}
        Finanzas={Finanzas}
      />


      {clientesDetailsDialog && (
        <ModalClientesDetails
          IdCustomer={IdCustomer}
          setClientesDetailsDialog={setClientesDetailsDialog}
          clientesDetailsDialog={clientesDetailsDialog}
        />
      )}

      {showDialogInscripcion && (
        <ReusableDialog
          visible={showDialogInscripcion}
          onHide={() => {
            setShowDialogInscripcion(false);
            setProveedorMail(undefined)
          }}
          header={"Enviar Correo a Cliente"}
          ejecutar={() => { EnviarCorreoInscripcion() }}
          Id={proveedorMail?.IdCustomer}
          enlace={`${process.env.REACT_APP_WERE_URL}/inscripcionClientes/${idioma}/${enlace?.enlace}`}
          correoAEnviar={correoAEviar}
          setCorreoAEnviar={setCorreoAEviar}
          idioma={idioma}
          setIdioma={setIdioma}
          setLoading={setLoadingCorreo}
          loading={loadingCorreo}
        />
      )}

      {showConvenio && (
        <ConvenioCRUD
          showConvenio={showConvenio}
          setShowConvenio={setShowConvenio}
          selected={selected}
          setSelected={setSelected}
        />
      )}


      <div style={{ display: 'none' }}>
        <div id='CorreoInscripcion'>
          <CorreoInscripcion enlace={enlace?.enlace} cliente={enlace?.CustomerName} idioma={idioma} />
        </div>
      </div>
    </div>
  );
}

export default ClientesScreen